import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";
import Cookies from "js-cookie";

const getUserid = Cookies.get("userid");

export const modify_files = (
  id,
  subject,
  content,
  status,
  filename,
  updateTime,
  locating,
  subjectlocating
) => {
  return api.post(`${ApiEndpointConstants.MODIFYMODEL}`, {
    id,
    userid: getUserid,
    subject,
    content,
    status,
    filename,
    updateTime,
    locating,
    subjectlocating,
  });
};
